import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { FaHandshake, FaArrowRight } from 'react-icons/fa';
import SectionHeader from '../SectionHeader/SectionHeader';
import { motion } from 'framer-motion';

class JoinCommunity extends Component {
    render() {
        return (
            <section className="relative py-20 sm:py-24 md:py-28 lg:py-32 flex items-center justify-center overflow-hidden">
                {/* Top fade from previous section */}
                <div className="absolute top-0 left-0 right-0 h-8 bg-gradient-to-b from-primary-50 to-transparent"></div>

                {/* Top accent line — brand orange */}
                <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-secondary-300 via-secondary-500 to-secondary-300"></div>

                {/* Centered accent pip */}
                <div className="absolute top-2 left-1/2 transform -translate-x-1/2 w-24 h-1 bg-secondary-400 rounded-full"></div>

                {/* Parallax Background Image */}
                <div className="absolute inset-0 w-full h-full overflow-hidden">
                    <div
                        className="parallax-bg w-full h-full bg-cover bg-center bg-fixed"
                        style={{ backgroundImage: 'url("images/community-distribution.jpeg")' }}
                    ></div>
                    {/* Dark overlay */}
                    <div className="absolute inset-0" style={{ background: 'rgba(13, 22, 48, 0.75)' }}></div>
                </div>

                {/* Content */}
                <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 text-center">
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                        viewport={{ once: true }}
                        className="max-w-4xl mx-auto"
                    >
                        {/* Section Header */}
                        <SectionHeader
                            badge="Come Join Us"
                            title="Be a part of something bigger."
                            accentWord="bigger."
                            subtitle="At SOYAN, we believe in the power of youth to shape peaceful, inclusive, and resilient communities."
                            variant="dark"
                            align="center"
                            className="mb-6 sm:mb-8"
                        />

                        {/* Action dividers */}
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8, delay: 0.5 }}
                            viewport={{ once: true }}
                            className="flex flex-wrap justify-center gap-4 md:gap-6 mb-8 text-white/70"
                        >
                            <span className="text-lg font-medium">Volunteer</span>
                            <span className="text-secondary-400 text-lg font-medium">|</span>
                            <span className="text-lg font-medium">Donate</span>
                            <span className="text-secondary-400 text-lg font-medium">|</span>
                            <span className="text-lg font-medium">Partner with Us</span>
                        </motion.div>

                        {/* CTA Button — brand orange */}
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8, delay: 0.6 }}
                            viewport={{ once: true }}
                        >
                            <Link
                                to="/contact"
                                className="inline-flex items-center gap-2 sm:gap-3 bg-primary-600 hover:bg-primary-700 text-white font-bold text-base sm:text-lg md:text-xl py-3 sm:py-4 px-6 sm:px-8 md:px-10 rounded-xl transition-all duration-300 transform hover:scale-105 shadow-2xl hover:shadow-3xl border border-primary-400/30"
                            >
                                <FaHandshake className="text-xl sm:text-2xl" />
                                <span className="hidden sm:inline">JOIN OUR COMMUNITY</span>
                                <span className="sm:hidden">JOIN US</span>
                                <FaArrowRight className="text-lg sm:text-xl transition-transform duration-300 group-hover:translate-x-1" />
                            </Link>
                        </motion.div>
                    </motion.div>
                </div>

                {/* Bottom navy bar */}
                <div className="absolute bottom-0 left-0 right-0 h-2 bg-gradient-to-r from-primary-800 to-primary-900"></div>
            </section>
        );
    }
}

export default JoinCommunity;
